module.exports = __webpack_public_path__ + "img/avatar3.2a24ab66.png";